module.exports = __webpack_public_path__ + "static/media/ca61127dd95f2e6473303320dba757fa9c1d45e1-24x24.4371e92a.png";